import React from "react";

type ButtonProps = {
  text?: string;
  backgroundColor?: string;
  textColor?: string;
  fontSize?: string | number;
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  padding?: string;
  border?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  className?: string;
  disabled?: boolean;
};

const Button: React.FC<ButtonProps> = ({
  text = "Button",
  backgroundColor,
  textColor,
  fontSize,
  width,
  height,
  borderRadius,
  padding,
  border,
  onClick,
  style,
  className,
  disabled = false,
}) => {
  const isBrandBlack = backgroundColor === "#000";
  
  const defaultStyle: React.CSSProperties = {
    background: isBrandBlack ? "linear-gradient(to right, #020712, #003AF0)" : undefined,
    boxShadow: isBrandBlack ? "0px 2px 4px -2px rgba(0, 0, 0, 0.1), 0px 4px 6px -1px rgba(0, 0, 0, 0.1)" : undefined,
    backgroundColor: isBrandBlack ? undefined : (backgroundColor || "#007bff"),
    color: textColor || "#fff",
    fontSize: fontSize || "16px",
    width: width || "auto",
    height: height || "auto",
    borderRadius: borderRadius || "12px",
    padding: padding || "5px 10px",
    border: border || "none",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.6 : 1,
    outline: "none",
  };

  return (
    <button
      onClick={disabled ? undefined : onClick}
      style={{ ...defaultStyle, ...style }}
      className={className}
      disabled={disabled}
      aria-disabled={disabled}
    >
      {text}
    </button>
  );
};

export default Button;
